import { createStore } from 'satcheljs';
var mailFaviconStoreData = {
    unseenMessages: 0,
};
var mailFavIconStore = createStore('mailFaviconStore', mailFaviconStoreData);
export default mailFavIconStore;
//# sourceMappingURL=store.js.map